// extracted by mini-css-extract-plugin
export default {"cartItem":"styles_cartItem__AWgf1","cartPopup":"styles_cartPopup__8VMcX","CartUpdate":"styles_CartUpdate__e51sM"};